import { FlowEvaluationType } from 'flow-schema';

import { type api } from 'common';

export function getDefaultEvaluationConfig(): api.FlowDefinition.EvaluationBlockConfig {
  return {
    output: '',
    reference: '',
    evaluationType: FlowEvaluationType.Accuracy,
  };
}
